module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._l((_vm.components), function(widget, k) {
    return _c(widget.name, {
      key: widget.uuid,
      tag: "component",
      attrs: {
        "data-uuid": widget.uuid,
        "data": widget
      }
    })
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "35vw"
    },
    attrs: {
      "element-loading-text": "加载中..."
    }
  }) : _vm._e(), _vm._v(" "), ((!_vm.error) && (!_vm.components.length)) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(1)]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/no-search.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 抱歉！暂时还没有商品\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/error.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 抱歉！出错了...\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-80f37aaa","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/Home/home.vue
// module id = 1061
// module chunks = 1